import type {AppSection} from '@frontend/types/GlobalStores'
import {create} from 'zustand/react'

// API хранилища общих данных приложения.
export interface AppRootStoreState {
    // Данные:

    // Приложение загружается?
    loading: boolean

    // Секция приложения.
    section: AppSection

    // API:

    // Задать состояние загрузки приложения.
    setIsLoading: (loading: boolean) => void

    // Задать секцию приложения.
    setAppSection: (section: AppSection) => void
}

// Хранилище общих данных приложения, связанных с загрузкой и разделением по секциям.
export const useAppRootStore = create<AppRootStoreState>(set => ({
    loading: true,
    section: 'public',

    // API:

    setIsLoading(loading: boolean): void {
        set({loading})
    },

    setAppSection(section: AppSection): void {
        set({section})
    },
}))
